// extracted by mini-css-extract-plugin
module.exports = {"sidebarandcontent":"style_sidebarandcontent__2RPv-","bodyContainer":"style_bodyContainer__2Wc2r","container":"style_container__348QW"};